import styles from "./SignInLayout.module.scss";
export default function SignInLayout({ children }) {
  return (
    <div className={styles.background}>
      <div className={styles.innerLayout}>{children}</div>
    </div>
  );
}
